import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import ReactModal from 'react-modal';

import 'app/common/configureSentry';

ReactModal.setAppElement('#app');

import UpdatedAppointmentScheduler from './components/UpdatedAppointmentScheduler';
import API from './utils/api-v2';

const api = new API(window.scheduler_link_uuid);

let basename = window.location.pathname;
const chunks = window.location.pathname.split('/').filter(chunk => chunk);
const ROUTES = ['confirmed', 'select-time', 'info', 'cancelled', 'tour-passed', 'reschedule', 'nearby-community'];
if (ROUTES.indexOf(chunks[chunks.length - 1]) > -1) {
    basename = chunks.slice(0, -1).join('/');
}
// If the route contains 'nearby-community' then remap the basename so
// the root path is set behind /nearby-community/1234 and react is able to to the virtual route mapping
if (chunks.find(chunk => chunk === 'nearby-community')) {
    basename = chunks.slice(0, -2).join('/');
}
// Prepend '/' to be able to do redirects
if (!basename.startsWith('/')) {
    basename = '/'.concat(basename);
}
// Remove the trailing '/' to be able to do redirects
if (basename.endsWith('/')) {
    basename = basename.slice(0, -1);
}
ReactDOM.render(
    <UpdatedAppointmentScheduler API={api} basename={basename} mapboxToken={window.MAPBOX_ACCESS_TOKEN} />,
    document.querySelector('#app')
);
